"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextStyle = exports.CrossIconContainer = exports.CrossIcon = exports.SharePostIcon = exports.WhatsApp = exports.TwitterIcon = exports.LinkedinIcon = exports.FacebookIcon = exports.BottomSheetHeader = exports.DropdownList = exports.DropdownListWrapper = exports.BottomBorder = exports.ButtonWrapper = exports.SharePost = exports.CompositionWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const building_blocks_ui_typography_1 = require("@acko-tech/building-blocks.ui.typography");
const facebook_1 = __importDefault(require("./icons/facebook"));
const twitter_1 = __importDefault(require("./icons/twitter"));
const whatsapp_1 = __importDefault(require("./icons/whatsapp"));
const linkedin_1 = __importDefault(require("./icons/linkedin"));
const shareposticon_1 = __importDefault(require("./icons/shareposticon"));
const cross_icon_1 = __importDefault(require("./icons/cross-icon"));
exports.Wrapper = styled_components_1.default.div `
  width: fit-content;
  height: 0;
`;
exports.CompositionWrapper = styled_components_1.default.div `
  display: block;
  width: 50%;
  height: 500vh;
  margin: auto;
  background: ${(props) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.light) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.n600; }};
`;
exports.SharePost = styled_components_1.default.div `
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  cursor: pointer;
  align-items: center;
`;
exports.ButtonWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  align-items: center;
  cursor: pointer;
  padding: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.spacing) === null || _b === void 0 ? void 0 : _b[4]; }};

  @media (max-width: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.m; }}px) {
    padding: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.spacing) === null || _b === void 0 ? void 0 : _b[6]; }};
    cursor: pointer;
  }
`;
exports.BottomBorder = styled_components_1.default.div `
  @media (max-width: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.m; }}px) {
    border-bottom: 1px solid
      ${(props) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.light) === null || _c === void 0 ? void 0 : _c.neutral) === null || _d === void 0 ? void 0 : _d.n200; }};
    margin: 0 ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.spacing) === null || _b === void 0 ? void 0 : _b[6]; }};
  }
`;
exports.DropdownListWrapper = styled_components_1.default.div `
  animation: fadeIn 0.2s ease;
  position: relative;
  top: 20px;
  left: -150px;
  width: 240px;
  height: 224px;
  z-index: 10;

  @media (max-width: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.m; }}px) {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    cursor: default;
    z-index: 101;
    background: ${(props) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.light) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.n600; }}B3;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
exports.DropdownList = styled_components_1.default.div `
  box-shadow: rgb(8 12 41 / 10%) 0px 4px 35px;
  border-radius: ${(props) => { var _a, _b, _c; return (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.border) === null || _b === void 0 ? void 0 : _b.radius) === null || _c === void 0 ? void 0 : _c.large; }};
  z-index: 10;
  background: ${(props) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.light) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.n0; }};
  overflow-y: auto;
  cursor: default;
  padding: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.spacing) === null || _b === void 0 ? void 0 : _b[2]; }} 0;

  @media (max-width: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.m; }}px) {
    position: fixed;
    left: 0;
    top: auto;
    bottom: 0;
    width: 100%;
    padding: 0;
    border-radius: ${(props) => { var _a, _b, _c; return (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.border) === null || _b === void 0 ? void 0 : _b.radius) === null || _c === void 0 ? void 0 : _c.max; }}
      ${(props) => { var _a, _b, _c; return (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.border) === null || _b === void 0 ? void 0 : _b.radius) === null || _c === void 0 ? void 0 : _c.max; }} 0 0;
    transform: ${(props) => ((props === null || props === void 0 ? void 0 : props.closing) ? 'translateY(100%)' : null)};
    animation: slideUp 0.25s ease;
  }

  @keyframes slideUp {
    0% {
      transform: translateY(200px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;
exports.BottomSheetHeader = styled_components_1.default.div `
  display: none;
  align-items: center;
  color: ${(props) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.light) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.n600; }};
  font-size: ${(props) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.typography) === null || _b === void 0 ? void 0 : _b.fonts) === null || _c === void 0 ? void 0 : _c.size) === null || _d === void 0 ? void 0 : _d.T2; }};
  font-weight: ${(props) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.typography) === null || _b === void 0 ? void 0 : _b.fonts) === null || _c === void 0 ? void 0 : _c.weight) === null || _d === void 0 ? void 0 : _d.T2; }};
  padding: ${(props) => { var _a, _b, _c, _d, _e, _f, _g, _h; return ` ${(_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.spacing) === null || _b === void 0 ? void 0 : _b[7]} ${(_d = (_c = props === null || props === void 0 ? void 0 : props.theme) === null || _c === void 0 ? void 0 : _c.spacing) === null || _d === void 0 ? void 0 : _d[7]} ${(_f = (_e = props === null || props === void 0 ? void 0 : props.theme) === null || _e === void 0 ? void 0 : _e.spacing) === null || _f === void 0 ? void 0 : _f[2]} ${(_h = (_g = props === null || props === void 0 ? void 0 : props.theme) === null || _g === void 0 ? void 0 : _g.spacing) === null || _h === void 0 ? void 0 : _h[6]}`; }};
  background: ${(props) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.light) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.n0; }};
  position: sticky;
  top: 0;
  cursor: default;
  border-bottom: ${(props) => props.heading && `0.5px solid #e7e7f0;`};

  @media (max-width: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.m; }}px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
exports.FacebookIcon = (0, styled_components_1.default)(facebook_1.default) `
  @media (max-width: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.m; }}px) {
    width: 15.83px;
    height: 15.83px;
    fill: black;
  }
`;
exports.LinkedinIcon = (0, styled_components_1.default)(linkedin_1.default) `
  @media (max-width: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.m; }}px) {
    width: 15.83px;
    height: 15.83px;
    fill: black;
  }
`;
exports.TwitterIcon = (0, styled_components_1.default)(twitter_1.default) `
  @media (max-width: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.m; }}px) {
    width: 15.83px;
    height: 15.83px;
    fill: black;
  }
`;
exports.WhatsApp = (0, styled_components_1.default)(whatsapp_1.default) `
  @media (max-width: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.m; }}px) {
    width: 15.83px;
    height: 15.83px;
    fill: black;
  }
`;
exports.SharePostIcon = (0, styled_components_1.default)(shareposticon_1.default) ``;
exports.CrossIcon = (0, styled_components_1.default)(cross_icon_1.default) `
  cursor: pointer;
  @media (max-width: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.m; }}px) {
    width: 14px;
    height: 14px;
  }
`;
exports.CrossIconContainer = styled_components_1.default.div ``;
exports.TextStyle = (0, styled_components_1.default)(building_blocks_ui_typography_1.T4_M) `
  @media (max-width: ${(props) => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.m; }}px) {
    font-size: 16px;
    color: ${(props) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.light) === null || _c === void 0 ? void 0 : _c.primary) === null || _d === void 0 ? void 0 : _d.n600; }};
  }
`;
//# sourceMappingURL=social-share-widget-styles.js.map